module.exports = __webpack_public_path__ + "img/VIETBANK.4c31efe6.svg";